module.exports = __webpack_public_path__ + "media/images/lt-335dcd26.svg";